import { createFileRoute } from '@tanstack/react-router';

import { WorkersPage } from '@/features/workers/components/WorkersPage';

export const Route = createFileRoute('/admin/workers')({
  component: WorkersPage,
});
